'use client';

import { type PropsWithChildren } from 'react';

export default function CancelAnytimeLink({ children }: PropsWithChildren) {
	return (
		<a
			href="https://support.calm.com/hc/en-us/articles/115002473607-How-to-turn-off-auto-renewal-or-cancel-my-subscription"
			target="_blank"
			rel="noreferrer"
		>
			{children}
		</a>
	);
}
